// Project images - Entorno Multiplayer
import entornoImg1 from '@/assets/projects/image.png';
import entornoImg2 from '@/assets/projects/imagen-de-whatsapp-2023-04-10-a-las-15.17.55-700x700.jpg';
import entornoImg3 from '@/assets/projects/imagen-de-whatsapp-2023-04-10-a-las-15.21.01-700x700.jpg';
import entornoImg4 from '@/assets/projects/image-2-700x700.png';
import entornoVideo from '@/assets/Videos/Lyc-Demo_comp.mp4';

// Project images - Minijuegos
import minijuegosImg1 from '@/assets/projects/captura-de-pantalla-2025-02-20-154552-700x700.png';
import minijuegosImg2 from '@/assets/projects/captura-de-pantalla-2025-02-20-154536-700x700.png';
import minijuegosImg3 from '@/assets/projects/captura-de-pantalla-2025-02-20-154641-700x700.png';
import minijuegosImg4 from '@/assets/projects/quizgato-portada-700x700.png';
import minijuegosImg5 from '@/assets/projects/captura-de-pantalla-2025-02-20-154623-700x700.png';
import minijuegosImg6 from '@/assets/projects/captura-de-pantalla-2025-02-20-154609-700x700.png';
import minijuegosImg7 from '@/assets/projects/quizgato-portada.png';

// Project images - Popau
import popauImg1 from '@/assets/projects/3-escaner-tablet-700x700.png';
import popauImg2 from '@/assets/projects/4-protecttheearth-tablet-1-700x700.png';
import popauImg3 from '@/assets/projects/producto-starterpack-1-700x700.png';
import popauImg4 from '@/assets/projects/starterpack-700x568.png';
import popauImg5 from '@/assets/projects/2-fuego-tablet-700x700.png';
import popauImg6 from '@/assets/projects/producto-sobres-x5-700x700.png';
import popauImg7 from '@/assets/projects/popau-rey-leon2-scaled.jpg';

// Project images - Coterie
import coterieImg1 from '@/assets/projects/dsc-6995-scaled.jpg';
import coterieVideo from '@/assets/projects/lyc-hololens-coterie1.mp4';

// Project images - Arcadia Earth Toronto
import arcadiaTorontoImg1 from '@/assets/projects/arcadia-earth-2-700x700.jpg';
import arcadiaTorontoImg2 from '@/assets/projects/arcadia-earth-700x700.jpg';
import arcadiaTorontoImg3 from '@/assets/projects/photo0jpg-700x700.jpg';
import arcadiaTorontoImg4 from '@/assets/projects/arcadia-earth-3-700x700.jpg';

// Project images - Arcadia Edu
import arcadiaEduImg1 from '@/assets/projects/img-2524-700x642.jpg';
import arcadiaEduImg2 from '@/assets/projects/img-2517-700x642.jpg';
import arcadiaEduImg3 from '@/assets/projects/img-2522-700x642.jpg';
import arcadiaEduImg4 from '@/assets/projects/ice-700x700.jpg';
import arcadiaEduImg5 from '@/assets/projects/coast-700x700.jpg';
import arcadiaEduImg6 from '@/assets/projects/desert-700x642.jpg';
import arcadiaEduImg7 from '@/assets/projects/img-2505-700x642.jpg';
import arcadiaEduImg8 from '@/assets/projects/forest-700x642.jpg';
import arcadiaEduImg9 from '@/assets/projects/captura-de-pantalla-2025-02-20-153543-700x700.png';

// Project images - Arcadia HoloLens NY
import arcadiaHololensImg1 from '@/assets/projects/arcadia-earth-1-scaled-r1sb95a5degtrmznyvdoclpjrd9f7zubtk0gdrekl4.jpg';
import arcadiaHololensImg2 from '@/assets/projects/arcadia-earth-2-scaled-r1sb967zk8i438yatdsax3h0cr4sfoy25onxv1d6ew.jpg';
import arcadiaHololensImg3 from '@/assets/projects/shark-1-2-scaled-r1sb93egzqe94f2e9ukf7m6mklioslmv5aphf7hcxk.jpg';
import arcadiaHololensImg4 from '@/assets/projects/arcadia-earth-3-scaled-r1sb983nxwkoqgvkielk22zxjiviv35itxywtlae2g.jpg';
import arcadiaHololensImg5 from '@/assets/projects/arcadia-earth-2-scaled-1.webp';

// Project images - Arcadia Las Vegas
import arcadiaLVImg1 from '@/assets/projects/captura-de-pantalla-2025-02-20-130012-700x700.png';
import arcadiaLVImg2 from '@/assets/projects/captura-de-pantalla-2025-02-20-130024-700x700.png';
import arcadiaLVImg3 from '@/assets/projects/captura-de-pantalla-2025-02-20-130055-700x700.png';
import arcadiaLVImg4 from '@/assets/projects/captura-de-pantalla-2025-02-20-125848-700x700.png';
import arcadiaLVImg5 from '@/assets/projects/arcadia-earth-cr-francis-george-ld-r745x419-700x700.jpg';
import arcadiaLVImg6 from '@/assets/projects/captura-de-pantalla-2025-02-20-130355-700x700.png';
import arcadiaLVImg7 from '@/assets/projects/ae5cf21c31600368b906c6b9cbcb8f2-700x700.jpg';
import arcadiaLVImg8 from '@/assets/projects/descarga-700x700.jpeg';
import arcadiaLVImg9 from '@/assets/projects/descarga-1-700x700.jpeg';
import arcadiaLVImg10 from '@/assets/projects/captura-de-pantalla-2025-02-20-125742-700x700.png';

// Project images - Arcadia NY
import arcadiaNYImg1 from '@/assets/projects/arcadia-earth-2-700x700.jpg';
import arcadiaNYImg2 from '@/assets/projects/arcadia-earth-700x700.jpg';
import arcadiaNYImg3 from '@/assets/projects/captura-de-pantalla-2025-02-20-120935-700x700.png';
import arcadiaNYImg4 from '@/assets/projects/captura-de-pantalla-2025-02-20-121220-700x700.png';
import arcadiaNYImg5 from '@/assets/projects/captura-de-pantalla-2025-02-20-121149-700x700.png';
import arcadiaNYImg6 from '@/assets/projects/captura-de-pantalla-2025-02-20-121011-700x700.png';
import arcadiaNYImg7 from '@/assets/projects/photo0jpg-700x700.jpg';
import arcadiaNYImg8 from '@/assets/projects/arcadia-earth-3-700x700.jpg';

// Project images - Lyceum
import lyceumImg1 from '@/assets/projects/captura-de-pantalla-2025-02-19-163011-700x700.png';
import lyceumImg2 from '@/assets/projects/captura1-700x667.png';
import lyceumImg3 from '@/assets/projects/clase-700x700.jpg';
import lyceumImg4 from '@/assets/projects/exosfera-700x700.png';
import lyceumImg5 from '@/assets/projects/captura-de-pantalla-2025-02-19-163452-700x700.png';
import lyceumImg6 from '@/assets/projects/invertebrados-700x700.png';
import lyceumImg7 from '@/assets/projects/captura-de-pantalla-2025-02-19-162941-700x700.png';
import lyceumImg8 from '@/assets/projects/captura-de-pantalla-2025-02-19-163427-700x700.png';
import lyceumImg9 from '@/assets/projects/sistemadecimal-700x700.png';
import lyceumImg10 from '@/assets/projects/sistemadecimal.png';

// Project images - Arcoutada
import arcoutadaImg1 from '@/assets/projects/lyceum-ar-countada.png';
import arcoutadaImg2 from '@/assets/projects/1612872885747-700x700.jpg';
import arcoutadaImg3 from '@/assets/projects/750x750bb-3-700x700.jpeg';
import arcoutadaImg4 from '@/assets/projects/1612872885740-700x700.jpg';
import arcoutadaImg5 from '@/assets/projects/pet-coutada-02-700x700.jpg';
import arcoutadaImg6 from '@/assets/projects/1612872885740.jpg';

// Project images - Museum Feedback
import museumImg1 from '@/assets/projects/kappframework-nxuchw11-700x700.png';
import museumImg2 from '@/assets/projects/captura-de-pantalla-2025-02-19-185332-700x700.png';
import museumImg3 from '@/assets/projects/museum-feedback-documento-diseno-lyceumvr-700x700.jpg';
import museumImg4 from '@/assets/projects/memoria-museum-feedback-2-700x700.jpg';
import museumImg5 from '@/assets/projects/museum-feedback-documento-diseno-lyceumvr.jpg';

// Project images - WallBot
import wallbotImg1 from '@/assets/projects/Captura Esp32.webp';
import wallbotImg2 from '@/assets/projects/Server walferbot.webp';

// Project images - Disney World VR
import disneyVRImg1 from '@/assets/projects/disneyworldVR.webp';

export interface ProjectQuote {
  text: string;
  source: string;
}

export interface Project {
  id: string;
  title: string;
  shortTitle: string;
  description: string;
  fullDescription: string[];
  platform: string;
  technology: string[];
  client: string;
  date: string;
  location: string;
  image?: string;
  images?: string[];
  videoUrl?: string;
  videoFile?: string;
  externalUrl?: string;
  externalUrlLabel?: string;
  instagramPosts?: string[];
  quotes?: ProjectQuote[];
  featured?: boolean;
  // English translations (optional)
  descriptionEn?: string;
  fullDescriptionEn?: string[];
}

export const projects: Project[] = [
  // 1. Popau AR (2024)
  {
    id: 'popau-ar-trading-cards',
    title: 'Popau Elements (AR Trading Cards)',
    shortTitle: 'Popau AR',
    description:
      'App/videojuego de realidad aumentada con cartas coleccionables sobre elementos de la naturaleza.',
    fullDescription: [
      'Hacer lo educativo mainstream con **realidad aumentada**.',
      'Se creo una colección de **24 cartas** sobre los elementos de la naturaleza.',
      'Desarrollé una **app/videojuego** que detecta estas cartas y posiciona la **versión 3D animada** del elemento al que representa las cartas.',
      'Cree un **sistema de interacción entre cartas**, que al juntarlas generan nuevos elementos.',
      'Sistema principal usa **ARFoundation**, pero se desarrollo un **sistema AR propio con OpenCV** para los dispositivos no compatibles con ARCore.',
      'Videojuego interno **«Protect The Earth»** estilo tower defense, en el que con las cartas reales desbloqueadas podemos evitar que destruyan la tierra.',
      'Pagina web del producto: **www.popau.cards**',
    ],
    platform: 'iOS & Android',
    technology: ['Unity', 'ARFoundation', 'OpenCV', 'C#'],
    client: 'Lyceum VR (Producto Propio)',
    date: '2024',
    location: 'Madrid',
    image: popauImg7,
    images: [popauImg7, popauImg3, popauImg5, popauImg1, popauImg2, popauImg4, popauImg6],
    videoUrl: 'https://www.youtube.com/embed/7alChuY2tzI',
    externalUrl: 'https://popau.cards/',
    externalUrlLabel: 'Ir a la web de Popau',
    featured: true,
  },
  // 2. Arcadia Toronto (2022)
  {
    id: 'arcadia-earth-ar-toronto',
    title: 'Arcadia Earth AR (Toronto)',
    shortTitle: 'Arcadia Toronto',
    description:
      'Experiencia de Realidad Aumentada completa para la exhibición de Toronto.',
    fullDescription: [
      'Experiencia de **Realidad Aumentada** en Toronto.',
      '**Desarrollo completo** de App en Unity con **ARFoundation**.',
      'Se usó **image tracking** para el posicionamiento de **más de 25 animaciones** a lo largo de la exhibición.',
      'Desarrollo de **portales en realidad aumentada** inmersivos.',
      'Se utilizó **Google Cloud Storage** para el almacenaje de fotos hechas por los clientes.',
      'Sistema de **quiz y formularios** conectados a una base de datos para la recopilación de datos y estadísticas.',
    ],
    platform: 'iOS & Android',
    technology: ['Unity', 'ARFoundation', 'Google Cloud Storage', 'C#'],
    client: 'Arcadia Earth Toronto',
    date: '2023',
    location: 'Toronto',
    image: arcadiaTorontoImg1,
    images: [arcadiaTorontoImg1, arcadiaTorontoImg2, arcadiaTorontoImg3, arcadiaTorontoImg4],
    instagramPosts: [
      'https://www.instagram.com/reel/DD2H1wLOsun/?utm_source=ig_embed&utm_campaign=loading',
      'https://www.instagram.com/reel/C2Dp5d0uRil/?utm_source=ig_embed&utm_campaign=loading',
    ],
  },
  // 3. Arcadia HoloLens - New York (2021)
  {
    id: 'arcadia-hololens-ny',
    title: 'Arcadia HoloLens NY',
    shortTitle: 'Arcadia HoloLens - New York',
    description:
      'Escaneo y trackeo completo de exhibición de 1400 metros cuadrados con HoloLens 2.',
    fullDescription: [
      'Escaneo y Trackeo completo de exhibición de **1400 metros cuadrados** (2 plantas, 15 habitaciones).',
      'Desarrollé **desde cero un sistema de posicionamiento local** para toda la exhibición.',
      'Cada HoloLens 2 sabía en todo momento en **qué habitación y piso se encontraba**.',
      'El hito consistió en llenar toda la exhibición de **objetos y animaciones virtuales** posicionadas en sitios concretos.',
      'Se usaba **un solo dispositivo** para escanear en 3D el museo entero, el sistema generaba automáticamente **anchors y un camino virtual**.',
      'El sistema permitía al dispositivo empezar la experiencia en cualquier parte del museo, **localizándose en menos de 2 segundos**.',
    ],
    platform: 'HoloLens 2',
    technology: ['Unity', 'XR', 'MRTK', 'Spatial Mapping', 'C#'],
    client: 'Arcadia Earth',
    date: '2022',
    location: 'Nueva York',
    image: arcadiaHololensImg1,
    images: [arcadiaHololensImg1, arcadiaHololensImg2, arcadiaHololensImg3, arcadiaHololensImg4, arcadiaHololensImg5],
    quotes: [
      {
        text: 'Arcadia Earth, the Awesome Augmented Reality Exhibit',
        source: 'Global Heroes',
      },
      {
        text: 'This next-generation art exhibition, designed to reignite the conversation around today\'s most pressing environmental issues, is the first augmented-reality journey through planet Earth',
        source: 'Times Square Chronicles',
      },
    ],
    featured: true,
  },
  // 4. Disney VR (2023)
  {
    id: 'disney-world-vr-experience',
    title: 'Disney World VR Experience - Happily Ever After',
    shortTitle: 'Disney VR',
    description:
      'Recreación en realidad virtual del espectáculo "Happily Ever After" de Magic Kingdom usando projection mapping simulado en Unity.',
    fullDescription: [
      'Recreación inmersiva en **realidad virtual** del icónico espectáculo **"Happily Ever After"** de Magic Kingdom en Walt Disney World.',
      'Obtuve el **vídeo original del espectáculo** y lo proyecté sobre un **modelo 3D del castillo de Cenicienta** usando técnicas de **projection mapping simulado** dentro de Unity.',
      'Desarrollé **sistemas de partículas y VFX personalizados** para recrear los efectos de fuegos artificiales en 3D, sincronizados perfectamente con la música y el espectáculo original.',
      'Todos los efectos fueron **sincronizados manualmente** con el audio y vídeo del espectáculo para recrear la experiencia de estar físicamente presente en el parque.',
      'La experiencia está diseñada para **Meta Quest**, permitiendo a los usuarios sentir la magia del espectáculo como si estuvieran allí en persona.',
    ],
    platform: 'Meta Quest',
    technology: ['Unity', 'VR', 'VFX Graph', 'Particle Systems', 'Projection Mapping', 'C#'],
    client: 'Proyecto Personal',
    date: '2023',
    location: 'Madrid',
    image: disneyVRImg1,
    videoUrl: 'https://www.youtube.com/embed/vXFCHzucBKI',
    externalUrl: 'https://www.youtube.com/watch?v=vXFCHzucBKI',
    externalUrlLabel: 'Ver en YouTube',
    featured: true,
    descriptionEn:
      'Virtual reality recreation of Magic Kingdom\'s "Happily Ever After" show using simulated projection mapping in Unity.',
    fullDescriptionEn: [
      'Immersive **virtual reality** recreation of the iconic **"Happily Ever After"** show from Magic Kingdom at Walt Disney World.',
      'I obtained the **original show video** and projected it onto a **3D model of Cinderella Castle** using **simulated projection mapping** techniques within Unity.',
      'Developed **custom particle systems and VFX** to recreate the fireworks effects in 3D, perfectly synchronized with the original music and show.',
      'All effects were **manually synchronized** with the show\'s audio and video to recreate the experience of being physically present at the park.',
      'The experience is designed for **Meta Quest**, allowing users to feel the magic of the show as if they were there in person.',
    ],
  },
  // 5. WallBot IoT (2026)
  {
    id: 'wallbot-wallapop-monitor',
    title: 'WallBot - Monitor de Productos Wallapop con Display IoT',
    shortTitle: 'WallBot IoT',
    description:
      'Sistema de monitorización automatizada de productos en Wallapop con visualización en tiempo real mediante display TFT y ESP32-CAM.',
    fullDescription: [
      'Sistema de **monitorización automatizada** de productos en Wallapop con visualización en tiempo real mediante un **display TFT** conectado a un microcontrolador **ESP32-CAM**.',
      '**Backend**: Servidor **Python con FastAPI** que realiza scraping periódico de búsquedas configuradas en Wallapop, almacena los resultados en **base de datos SQLite** y genera imágenes optimizadas para el display.',
      '**Frontend Web**: Interfaz para configurar búsquedas, visualizar productos encontrados y gestionar alertas.',
      '**Hardware IoT**: ESP32-CAM con pantalla **TFT ST7735 (128x160px)** que muestra los productos encontrados, actualizándose cada **30 segundos via WiFi**.',
      '**Decodificación JPEG en tiempo real** con memoria limitada (30KB buffer).',
      'Control de backlight mediante **PWM** para ajuste de brillo.',
      '**Reconexión automática WiFi** y manejo de errores de red.',
      'Renderizado de imágenes con información de producto (precio, título, fecha).',
      '**Polling eficiente** con gestión de estados visuales.',
    ],
    platform: 'ESP32-CAM, Web, Docker',
    technology: ['Python', 'FastAPI', 'SQLite', 'Pillow', 'C++', 'Arduino', 'ESP32-CAM', 'TFT ST7735', 'SPI', 'PWM', 'IoT', 'Docker'],
    client: 'Proyecto Personal',
    date: '2026',
    location: 'Madrid',
    image: wallbotImg1,
    images: [wallbotImg1, wallbotImg2],
    externalUrl: 'https://github.com/fernandoolea/wallbot',
    externalUrlLabel: 'Ver en GitHub',
    featured: true,
  },
  // 6. Multiplayer AI (2023)
  {
    id: 'entorno-privado-multijugador',
    title: 'Entorno Multiplayer Multiplataforma con IA',
    shortTitle: 'Multiplayer AI',
    description: 'Entorno para reuniones privadas multiplataforma',
    fullDescription: [
      'Desarrollo de **entorno multiplayer** desarrollado en Unity usando **Photon**.',
      '**Multiplataforma** para Meta Quest, PC y WebGL.',
      '**Comunicación por voz**.',
      '**Interacción con objetos** entre usuarios.',
      'Desarrollo de **personaje con IA** usando la **API de OpenAI** para la generación de texto y **Azure DevOps** para la transcripción voz a texto y texto a voz.',
    ],
    platform: 'Meta Quest, PC, WebGL',
    technology: ['Unity', 'Photon', 'OpenAI', 'Azure', 'C#', 'VR', 'Multiplayer'],
    client: 'Producto Propio Lyceum VR',
    date: '2023',
    location: 'Madrid',
    image: entornoImg4,
    images: [entornoImg4, entornoImg1, entornoImg2, entornoImg3],
    videoFile: entornoVideo,
    featured: true,
  },
  // 7. Coterie NY (2023/2024)
  {
    id: 'coterie-2023',
    title: 'Coterie NY 2023/2024',
    shortTitle: 'Coterie NY',
    description:
      'La realidad extendida llega a la semana de la moda de Nueva York con HoloLens 2.',
    fullDescription: [
      'La realidad extendida llega a la semana de la moda de Nueva York.',
      '**Sistema de Location-Based Tracking completamente custom**, desarrollado desde cero sin dependencia de servicios de terceros como Azure Spatial Anchors u otras soluciones comerciales.',
      'A diferencia de las soluciones estándar que dependen de servicios cloud externos, este sistema utiliza **SLAM (Simultaneous Localization and Mapping) propio** para el posicionamiento preciso de elementos virtuales en espacios físicos.',
      'Con unas gafas HoloLens 2, se escanea el espacio y se guarda localmente, se calibra y posicionan los objetos en los sitios deseados. Después, las gafas suben esta información a **nuestro servidor propio**.',
      'El servidor comparte la información del espacio y de posicionamiento de objetos al resto de gafas, las cuales **no necesitan ser calibradas individualmente**.',
      'El objetivo del proyecto era poder desarrollar animaciones individuales en remoto, y una vez en el evento, situar estas animaciones en sincronía con los objetos reales.',
      '**Control centralizado de más de 40 HoloLens 2** desde un servidor con sincronización sin esfuerzo.',
    ],
    platform: 'HoloLens 2',
    technology: ['Unity', 'XR', 'MRTK', 'C#', 'Networking', 'Custom SLAM', 'Location-Based Tracking'],
    client: 'Scatola LLC',
    date: '2023/2024',
    location: 'Nueva York',
    image: coterieImg1,
    images: [coterieImg1],
    videoFile: coterieVideo,
    featured: true,
  },
  // 8. Lyceum VR (2020)
  {
    id: 'portfolio-lyceum-learning',
    title: 'Lyceum Learning (VR Education)',
    shortTitle: 'Lyceum VR',
    description:
      'Llevar la realidad virtual a las aulas de Educación Primaria.',
    fullDescription: [
      'Desarrollo de una **plataforma completa** para experiencias VR para **Meta Quest y PC**, con el uso de **Hand Tracking** para facilitar la interacción.',
      '**Más de 10 experiencias interactivas y guiadas**. Con una duración de más de 15 minutos cada una.',
      '**Experiencia Sandbox** para demostración en Ferias.',
      'Sistema de **localización** para la traducción a diferentes idiomas.',
      '**Hand tracking** con sistema de sincronización con la mesa de trabajo, para una inmersión completa.',
      'Conexión con **base de datos** para monitorización de estadísticas.',
    ],
    platform: 'Meta Quest & PC VR',
    technology: ['Unity', 'VR', 'XR Interaction Toolkit', 'Hand Tracking', 'C#'],
    client: 'Producto Propio Lyceum VR',
    date: '2020',
    location: 'Madrid',
    image: lyceumImg1,
    images: [lyceumImg1, lyceumImg2, lyceumImg3, lyceumImg4, lyceumImg5, lyceumImg6, lyceumImg7, lyceumImg8, lyceumImg9, lyceumImg10],
    videoUrl: 'https://www.youtube.com/embed/dWOWJZg-R0g',
    featured: true,
  },
  // 9. Arcadia Earth - Las Vegas (2022)
  {
    id: 'arcadia-earth-ar-las-vegas',
    title: 'Arcadia Earth AR (Las Vegas)',
    shortTitle: 'Arcadia Earth - Las Vegas',
    description:
      'Experiencia de Realidad Aumentada en el corazón de Las Vegas.',
    fullDescription: [
      'Experiencia de **Realidad Aumentada** en corazón de Las Vegas.',
      '**Desarrollo completo** de App en Unity con **ARFoundation**.',
      'Usé **image tracking** para el posicionamiento de **más de 25 animaciones** a lo largo de la exhibición.',
      'Desarrollo de **portales en realidad aumentada** inmersivos.',
      'Utilicé **Google Cloud Storage** para el almacenaje de fotos hechas por los clientes con los iPads pertenecientes a la exhibición, para su posterior envío a través de correo electrónico.',
      'Sistema de **4 iPads conectados a un servidor** que manejaba unos **paneles LEDs gigantes**. Los usuarios podían **cambiar los videos de las pantallas** seleccionándolo desde los iPads.',
      'Se desarrolló también un sistema de **quiz y formularios** conectados a una base de datos para la recopilación de datos y estadísticas.',
    ],
    platform: 'iOS & Android',
    technology: ['Unity', 'ARFoundation', 'Google Cloud Storage', 'Client/Server', 'C#'],
    client: 'Arcadia Earth',
    date: '2021',
    location: 'Las Vegas',
    image: arcadiaLVImg1,
    images: [arcadiaLVImg1, arcadiaLVImg2, arcadiaLVImg3, arcadiaLVImg4, arcadiaLVImg5, arcadiaLVImg6, arcadiaLVImg7, arcadiaLVImg8, arcadiaLVImg9, arcadiaLVImg10],
    externalUrl: 'https://www.youtube.com/watch?v=2HWr-aUQP1E',
    externalUrlLabel: 'Ver video',
    quotes: [
      {
        text: 'Experimenta nuestro planeta como nunca antes en el primer viaje inmersivo de realidad aumentada a través de la Tierra',
        source: 'TripAdvisor',
      },
      {
        text: 'Arcadia Earth: El primer viaje inmersivo de realidad aumentada a través del Planeta Tierra',
        source: 'Everything Immersive',
      },
    ],
  },
  // 10. Arcadia Earth - New York (2021)
  {
    id: 'arcadia-earth-ar-new-york',
    title: 'Arcadia Earth AR (New York)',
    shortTitle: 'Arcadia Earth - New York',
    description:
      'Experiencia de Realidad Aumentada en Broadway',
    fullDescription: [
      '**Desarrollo completo** de App en Unity con **ARFoundation**.',
      'Se usó **image tracking** para el posicionamiento de **más de 15 animaciones** a lo largo de la exhibición.',
      'Se utilizó **AWS** para el almacenaje de fotos hechas por los clientes con los iPads pertenecientes a la exhibición, para su posterior envío a través de correo electrónico.',
      'Se desarrolló también un sistema de **quiz y formularios** conectados a una base de datos para la recopilación de datos y estadísticas.',
    ],
    platform: 'iOS & Android',
    technology: ['Unity', 'ARFoundation', 'AWS', 'C#'],
    client: 'Arcadia Earth',
    date: '2021',
    location: 'Nueva York',
    image: arcadiaNYImg1,
    images: [arcadiaNYImg1, arcadiaNYImg2, arcadiaNYImg3, arcadiaNYImg4, arcadiaNYImg5, arcadiaNYImg6, arcadiaNYImg7, arcadiaNYImg8],
    videoUrl: 'https://www.youtube.com/embed/uThgV_keC7M',
    quotes: [
      {
        text: 'Arcadia Earth: Cómo la realidad aumentada y el arte se combinan para transformar la educación ambiental.',
        source: 'Forbes',
      },
      {
        text: 'Arcadia Earth: Una exposición inmersiva que usa realidad aumentada para inspirar acción contra el cambio climático.',
        source: 'The New York Times',
      },
    ],
  },
  // 11. Arcadia Edu - Verizon (2023)
  {
    id: 'arcadia-edu-verizon',
    title: 'Arcadia Edu (Verizon)',
    shortTitle: 'Arcadia Edu - Verizon',
    description:
      'Plataforma para la creación de lecciones en realidad aumentada vía web para Verizon.',
    fullDescription: [
      'Plataforma para la **creación de lecciones en realidad aumentada** vía web.',
      'App desarrollada en Unity dedicada a la **concienciación sobre el medio ambiente** para niños usando **Realidad Aumentada**.',
      'El sistema permite **crear lecciones via web**, que luego pueden ser reproducidas en la app en realidad aumentada.',
      'Conexión con **dashboard web** para el profesorado.',
      'Autentificación mediante **servidores de Verizon**.',
    ],
    platform: 'iOS',
    technology: ['Unity', 'AR', 'Web Dashboard', 'C#'],
    client: 'Verizon – Arcadia',
    date: '2023',
    location: 'EEUU',
    image: arcadiaEduImg1,
    images: [arcadiaEduImg1, arcadiaEduImg2, arcadiaEduImg3, arcadiaEduImg4, arcadiaEduImg5, arcadiaEduImg6, arcadiaEduImg7, arcadiaEduImg8, arcadiaEduImg9],
  },
  // 12. AR Coutada (2020)
  {
    id: 'arcoutada',
    title: 'AR Coutada (Vuforia)',
    shortTitle: 'AR Coutada',
    description:
      'Mostrar arte rupestre usando Realidad Aumentada',
    fullDescription: [
      'Los petroglifos son un tipo de arte rupestre prehistórico caracterizado por la utilización de las superficies pétreas al aire libre como soporte de los grabados de figuras animalísticas y diferentes motivos geométricos. Por el paso del tiempo, a veces es muy complejo ver todas las figuras y escenas representadas con grabados en la piedra. Por eso la App **AR COUTADA** con la tecnología de realidad aumentada nos permite disfrutar del conjunto en toda su magnitud, marcando y resaltando todos los detalles, hasta los imperceptibles.',
      'Usando **Vuforia Model Tracking**: Primero introduciendo en la app unos modelos hechos con fotogrametría de las rocas donde se encuentran los petroglifos, para luego detectar esas rocas usando model tracking para posicionar los petroglifos en las rocas y remarcar e señalar cada uno de los puntos de interés.',
      'Desarrollado en **Unity3D**.',
    ],
    platform: 'iOS & Android',
    technology: ['Unity', 'Vuforia', 'Model Tracking', 'Fotogrametría', 'AR', 'C#'],
    client: 'Concello de As Neves',
    date: '2020',
    location: 'Galicia',
    image: arcoutadaImg1,
    images: [arcoutadaImg1, arcoutadaImg2, arcoutadaImg3, arcoutadaImg4, arcoutadaImg5, arcoutadaImg6],
  },
  // 13. Museum Feedback (2021)
  {
    id: 'museum-feedback',
    title: 'Museum Feedback (Computer Vision)',
    shortTitle: 'Museum Feedback',
    description:
      'La emoción es el mejor indicador para medir la experiencia de usuario',
    fullDescription: [
      '**¿Qué es Museum_feedback?** Museum_feedback es una aplicación móvil que recoge datos subjetivos sobre los visitantes de un museo, analizando el feedback sobre obras o piezas específicas mediante reconocimiento facial, a través de una experiencia gamificada tipo quiz.',
      '**¿Qué funcionalidades tiene Museum_feedback?** La aplicación presenta una experiencia de juego tipo Quiz, un sistema de valoración de obras que incluye reconocimiento facial, una base de datos para recoger los datos y un panel de administración para visualizar los datos recogidos. Todo controlado por **comandos de voz**.',
      '**¿Cómo funciona el algoritmo de reconocimiento facial?** El algoritmo detectará los datos faciales de sus emociones durante el tiempo que se muestra la pantalla de valoración de la obra usando **OpenCV** y algoritmos basados en el posicionamiento de keypoints faciales. Además, reconoce la edad y el género del usuario.',
    ],
    platform: 'Android',
    technology: ['Unity', 'Computer Vision', 'OpenCV', 'Reconocimiento Facial', 'Comandos de Voz', 'C#'],
    client: 'Museo de la evolución humana',
    date: '2021',
    location: 'Castilla y León',
    image: museumImg1,
    images: [museumImg1, museumImg2, museumImg3, museumImg4, museumImg5],
  },
  // 14. Minijuegos 2D (2024)
  {
    id: 'minijuegos-infantiles',
    title: 'Minijuegos Infantiles 2D',
    shortTitle: 'Minijuegos 2D',
    description:
      'Desarrollo de 5 minijuegos 2D para plataforma educativa del Ministerio de Derechos Sociales.',
    fullDescription: [
      'Desarrollo de Minijuegos para el **Ministerio de Derechos Sociales**.',
      'Desarrollo de **5 minijuegos 2D** para plataforma educativa: **Memo, Puzzle, Quiz, Sopa de letras y unión de conceptos**.',
    ],
    platform: 'Windows',
    technology: ['Unity', '2D', 'C#'],
    client: 'Mares Virtuales',
    date: '2024',
    location: 'Madrid',
    image: minijuegosImg1,
    images: [minijuegosImg1, minijuegosImg2, minijuegosImg3, minijuegosImg4, minijuegosImg5, minijuegosImg6, minijuegosImg7],
    featured: true,
  },
];

export const featuredProjects = projects.filter((p) => p.featured);
